import React from 'react';
import store from '../../store/Store';

import { Link } from 'react-router-dom';

import Logo from '../logo/Logo';
import actions from '../../actions/Actions';
import Inputs from '../inputs/Inputs';
import Navigation from '../navigation/Navigation'
import './menu.scss';

type menuState = {
	login: {
		loggedIn
	},
	user: {
		id,
		title,
		name,
		lastName,
		gender,
		email,
		password,
		admin
	}
}

type menuProps = {
	login: {
		loggedIn
	},
	user: {
		id,
		title,
		name,
		lastName,
		gender,
		email,
		password,
		admin
	}
}

class Menu extends React.Component<menuState, menuProps> {

	constructor(props) {
		super(props);

		this.state = {
			login: {
				loggedIn: store.getState().login && store.getState().login.loggedIn ? store.getState().login.loggedIn : false
			},
			user: {
				id: store.getState().user && store.getState().user.id ? store.getState().user.id : 0,
				title: store.getState().user && store.getState().user.title ? store.getState().user.title : '',
				name: store.getState().user && store.getState().user.name ? store.getState().user.name : '',
				lastName: store.getState().user && store.getState().user.lastName ? store.getState().user.lastName : '',
				gender: store.getState().user && store.getState().user.gender ? store.getState().user.gender : -1,
				email: store.getState().user && store.getState().user.email ? store.getState().user.email : '',
				password: store.getState().user && store.getState().user.password ? store.getState().user.password : '',
        		admin: store.getState().user && store.getState().user.admin ? store.getState().user.admin : false
			}
		}

		this.handleChangeEmail = this.handleChangeEmail.bind(this);
		this.handleChangePassword = this.handleChangePassword.bind(this);
	}

	componentDidMount() {
		store.subscribe(() => {
			this.setState({
				login: {
					loggedIn: store.getState().login && store.getState().login.loggedIn ? store.getState().login.loggedIn : false
				},
				user: {
					id: store.getState().user && store.getState().user.id ? store.getState().user.id : 0,
					title: store.getState().user && store.getState().user.title ? store.getState().user.title : '',
					name: store.getState().user && store.getState().user.name ? store.getState().user.name : '',
					lastName: store.getState().user && store.getState().user.lastName ? store.getState().user.lastName : '',
					gender: store.getState().user && store.getState().user.gender ? store.getState().user.gender : -1,
					email: store.getState().user && store.getState().user.email ? store.getState().user.email : '',
					password: store.getState().user && store.getState().user.password ? store.getState().user.password : '',
        			admin: store.getState().user && store.getState().user.admin ? store.getState().user.admin : false
				}
			})
		})
	}

	handleChangeEmail = ((event) => {
		this.setState({ 
			"user": Object.assign(
				{},
				this.state.user,
				{
					email: event.target.value
				}
			)
		});
	})

	handleChangePassword = ((event) => {
		this.setState({
			"user": Object.assign(
				{},
				this.state.user,
				{
					password: event.target.value
				}
			)
		});
	})

	async putData() {
		await fetch(`http://localhost:3001/api/user/:id`, { 
			method: "PUT",
			mode: "cors",
			headers: {
			  'Accept': 'application/json',
			  'Content-Type': 'application/json'
			},
			body: JSON.stringify({ 
				email: this.state.user.email || '',
				password: this.state.user.password || ''
			})
		})
		.then(res => res.json())
		.then((data) => {
			console.log(data);
			this.setState({ 
				user: data 
			});
		})
		.catch(console.log)
	}

  render() {
	  return (
	    <div className="Menu">
	    	
	    </div>
	  );
  }
}

export default Menu;